













import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { gsap, CSSPlugin } from 'gsap/all';

import Overlay from './ui/Overlay.vue';
import Loader from './ui/Loader.vue';
import Modal from './ui/Modal.vue';
import MainHeader from './blocks/header/Header.vue';
import SidebarMenu from './blocks/sidebar/SidebarMenu.vue';
import MainFooter from './blocks/footer/Footer.vue';


gsap.registerPlugin(CSSPlugin);

@Component({
  components: {
    Overlay,
    Loader,
    Modal,
    MainHeader,
    SidebarMenu,
    MainFooter,
  },
})
export default class App extends Vue {

  private get version(): string {
    return this.$store.getters['app/version'];
  }

  private get overlayActive(): boolean {
    return this.$store.state.ui.overlay;
  }

  private created(): void {
    this.$router.beforeEach((to: Route, from: Route, next: any) => {
      this.$bus.$emit('progress-start');
      setTimeout(() => {
        next();
      }, 800);
    });
  }
}
